import { Button } from "antd";
import { useState } from "react";
import LottieIcon from "../../../../components/shared/lottieIcon/LottieIcon";

import viewIcon from "../../../../assets/icons/Eye.svg";
import editIcon from "../../../../assets/icons/Edit.svg";
import deleteIcon from "../../../../assets/icons/Delete.svg";
import CustomPopover from "../../../../components/shared/custompopover/CustomPopover";
import optionsIcon from "../../../../assets/icons/Options.svg"


const CourseActions = ({ record, navigate, onEditClick, onDeleteClick,status }) => {
  const [hoveredButton, setHoveredButton] = useState(null);
  const [visiblePopover, setVisiblePopover] = useState(null);

  const popoverContent = (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <Button
        onClick={() => {
          navigate(`/books/course-content/${record.courseId}`)
          setVisiblePopover(null);
        }}
        style={{ width: "11rem" }}
        className="navbar-item"
        onMouseEnter={() => setHoveredButton("view")}
        onMouseLeave={() => setHoveredButton(null)}
      >
        <span>View Course</span>
        {hoveredButton === "view" ? (
          <LottieIcon name="viewIcon" size={28} shouldPlay />
        ) : (
          <img src={viewIcon} alt="view-icon" height={28} />
        )}
      </Button>

      <Button
        onClick={() => {
          onEditClick(record);
          setVisiblePopover(null);
        }}
        style={{ width: "11rem" }}
        className="navbar-item"
        onMouseEnter={() => setHoveredButton("edit")}
        onMouseLeave={() => setHoveredButton(null)}
      >
        <span>Edit</span>
        {hoveredButton === "edit" ? (
          <LottieIcon name="editIcon" size={24} shouldPlay={true} />
        ) : (
          <img src={editIcon} alt="edit-icon" height={28} />
        )}
      </Button>

      <Button
        onClick={() => {
          navigate(`/books/course-report/${record.courseId}`);
          setVisiblePopover(null);
        }}
        style={{ width: "11rem" }}
        className="navbar-item"
        onMouseEnter={() => setHoveredButton("report")}
        onMouseLeave={() => setHoveredButton(null)}
      >
        <span>Report</span>
        {hoveredButton === "report" ? (
          <LottieIcon name="viewIcon" size={24} shouldPlay={true} />
        ) : (
          <img src={viewIcon} alt="report-icon" height={28} />
        )}
      </Button>

      <Button
        onClick={() => {
          navigate(`/course-content/${record.courseId}/quizzes`);
          setVisiblePopover(null);
        }}
        style={{ width: "11rem" }}
        className="navbar-item"
        onMouseEnter={() => setHoveredButton("quiz")}
        onMouseLeave={() => setHoveredButton(null)}
      >
        <span>{record.quizAvailable ? "Manage Quiz" : "Add Quiz"}</span>
        {hoveredButton === "quiz" ? (
          <LottieIcon name="viewIcon" size={24} shouldPlay={true} />
        ) : (
          <img src={viewIcon} alt="quiz-icon" height={28} />
        )}
      </Button>

      {status === "active" && (
        <Button
        onClick={() => {
          setVisiblePopover(null);
          onDeleteClick(record);
        }}
        style={{ width: "11rem" }}
        className="navbar-item"
        onMouseEnter={() => setHoveredButton("delete")}
        onMouseLeave={() => setHoveredButton(null)}
      >
        <span>Delete</span>
        {hoveredButton === "delete" ? (
          <LottieIcon name="trashIcon" size={24} shouldPlay={true} />
        ) : (
          <img src={deleteIcon} alt="delete-icon" height={28} />
        )}
      </Button>
      )}
    </div>
  );

  return (
    <CustomPopover
      content={popoverContent}
      trigger="click"
      className="admin-popover"
      placement="bottomRight"
      visible={visiblePopover === record.courseId}
      onVisibleChange={(visible) => {
        setVisiblePopover(visible ? record.courseId : null);
        if (!visible) setHoveredButton(null);
      }}
      getPopupContainer={() => document.body}
    >
      <img src={optionsIcon} alt="options-icon" height={24} />
    </CustomPopover>
  );
};

export default CourseActions;
